<template>
  <div class="gender_input">
    <Formfield :label="title" :required="required" :helpText="helpText">
      <RadioList
        v-model="mainGender"
        :columns="2"
        :required="required"
        :validationMessage="validationMessage"
        :isBlock="true"
        :options="options"
        @input="setGender"
      />
      <TextInput
        v-model="customGender"
        v-if="mainGender === 'other'"
        :label="otherGenderInputPlaceholder"
        :required="false"
        :valueMaxLength="20"
        :valueMaxLengthMessage="valueMaxLengthMessage"
        :displayValueMaxLength="true"
        :showClearButton="true"
        ref="customGenderInput"
        @input="setGender"
      />
    </Formfield>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import RadioList from "../atoms/Inputs/RadioList.vue";
import TextInput from "../atoms/Inputs/TextInput.vue";
import Formfield from "../molecules/Formfield.vue";
import FormMixin from "../mixins/FormMixin";

/**
 * @group Inputs
 * Inclusive Gender Input, people can select Female, Male, Rather Not Say or Other
 * When they select Other, they can either type their gender or submit it as Other
 */
export default {
  name: "GenderInput",
  mixins: [BaseComponent, FormMixin, BaseComponent],
  components: {
    RadioList,
    TextInput,
    Formfield,
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    validationMessage: {
      type: String,
      default: "Please select an option",
    },
    valueMaxLengthMessage: {
      type: Function,
      default: (valueMaxLength) =>
        `Value has more than ${valueMaxLength} characters`,
    },
    title: {
      type: String,
      default: "Gender",
    },
    genderOptionLabels: {
      type: Object,
      default: () => ({
        female: "Female",
        male: "Male",
        rather_not_say: "Rather not say",
        other: "other",
      }),
    },
    otherGenderInputPlaceholder: {
      type: String,
      default: "Your gender",
    },
    helpText: {
      type: String,
    },
  },
  data() {
    if (this.$attrs.value) {
      this.$emit("input", this.$attrs.value, this);
    }
    return {
      inputValue: this.value,
      customGender: null,
      mainGender: null,
    };
  },
  computed: {
    options() {
      return [
        {
          displayValue: this.genderOptionLabels.female,
          value: "female",
        },
        {
          displayValue: this.genderOptionLabels.male,
          value: "male",
        },
        {
          displayValue: this.genderOptionLabels.rather_not_say,
          value: "rather_not_say",
        },
        {
          displayValue: this.genderOptionLabels.other,
          value: "other",
        },
      ];
    },
  },
  watch: {
    value(value) {
      this.setValue(value);
    },
    inputValue(value) {
      this.$emit("input", value, this);
    },
    isValid() {
      this.$parent.$emit("validChange", this);
    },
    customGender(customGender) {
      if (!customGender) this.setGender("other");
    },
  },
  methods: {
    // @vuese
    // Sets the gender
    setGender(value) {
      let emitValue = value;
      if (this.customGender && this.mainGender === "other")
        emitValue = this.customGender;
      this.inputValue = emitValue;
    },
    setValue(value) {
      const mainGender = this.options.filter(
        (option) => option.value === value || option.displayValue === value
      )[0];
      if (!mainGender || mainGender.value === "other") {
        if (value === "other") {
          this.customGender = "";
        } else {
          this.customGender = value;
        }
        this.mainGender = "other";
      }
      if (mainGender) this.mainGender = mainGender.value;
    },
  },
  mounted() {
    this.$parent.$emit("validChange", this);
    if (this.value !== "") {
      this.setValue(this.value);
    }
  },
  beforeDestroy() {
    this.$parent.$emit("validChange", this, true);
  },
};
</script>
